import type { JSX } from 'react';
import { Routes, Route } from 'react-router';
import { RootLayout } from './routes/RootLayout';
import { Home } from './routes/Home';
import { Privacy } from './routes/Privacy';
import { Terms } from './routes/Terms';
import { ResponsiblePlay } from './routes/ResponsiblePlay';
import { Compliance } from './routes/Compliance';
import { NotFound } from './routes/NotFound';

/**
 * App route tree (D-06 / D-07 / RTE-01).
 *
 * All 6 routes nest under <RootLayout/> so Nav + Footer + useLangSync +
 * hreflang metadata are present on every route — including the catch-all 404
 * (RTE-02).
 *
 * React Router 7 Declarative mode (Phase 1 D-04 lock); imports come from
 * the unified 'react-router' package (the legacy DOM-suffixed package is not used).
 */
export default function App(): JSX.Element {
  return (
    <Routes>
      <Route element={<RootLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/responsible-play" element={<ResponsiblePlay />} />
        <Route path="/compliance" element={<Compliance />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
